import { fetchWithState, getFetchedJSON } from "~/misc/fetch";
import { ActionError } from "~/misc/dispatch";


const getParamAPI = (getState, {id, ...saveData}) =>{
  return fetchWithState(getState, {
    method: "GET",
    url: "/email-service/tl/email/param/"+id,
  })
    .then(getFetchedJSON)
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        throw new ActionError(error.response.statusText);
      }
      throw error;
    });
  }

    export const getParamByUrlAction = (getData) => (_, getSate) => {
      return getParamAPI(getSate, getData);
    }



// WEBPACK FOOTER //
// ./src/pages/EmailCampaignNew/apis/params.js